import React, { Component } from "react";
import IconButtonView from "presentational/common/IconButtonView";
import Typography from "@material-ui/core/Typography";
import TXT from "presentational/common/multinational/TXT";
import config from "lib/fr-config";
import PropTypes from "prop-types";

const ROOT_URL = config.rootURL;

const css = {
  root: {
    paddingTop: 250,
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  }
};

class DefaultErrorView extends Component {
  static propTypes = {
    backendServerErrorType: PropTypes.bool.isRequired
  };

  static defaultProps = {
    backendServerErrorType: false
  };

  handleRefreshClick = () => {
    window.location.replace(ROOT_URL);
  };

  getTextForBackendError() {
    return (
      <span>
        <Typography variant="subtitle1" align="center">
          <TXT name="msg_nowMaintenance" />
        </Typography>
        <Typography variant="subtitle1" align="center">
          <TXT name="msg_thxWaiting" />
        </Typography>
      </span>
    );
  }

  render() {
    const { backendServerErrorType } = this.props;

    return (
      <div style={css.root}>
        {backendServerErrorType ? this.getTextForBackendError() : null}
        <IconButtonView type={"refresh"} onClick={this.handleRefreshClick} />
      </div>
    );
  }
}

export default DefaultErrorView;
